import {useEffect, useState} from 'react';
import {useTelegramTheme} from '../utils/telegram';
import {api} from '../services/api';
import {retrieveLaunchParams, viewport} from '@tma.js/sdk-react';


export function UptimeBadge() {
    const themeParams = useTelegramTheme();
    const [uptime, setUptime] = useState(0);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    // Check if mobile platform
    useEffect(() => {
        try {
            const launchParams = retrieveLaunchParams();
            const platform = launchParams.tgWebAppPlatform;
            const mobile = platform === 'android' || platform === 'ios' || platform === 'android_x';
            setIsMobile(mobile);
        } catch (err) {
            console.warn('Failed to get platform:', err);
        }
    }, []);

    // Check fullscreen status
    useEffect(() => {
        if (!viewport.mount.isAvailable()) {
            // If viewport not available, assume fullscreen for mobile
            setIsFullscreen(true);
            return;
        }

        try {
            viewport.mount();

            // Wait a bit and check fullscreen state
            setTimeout(() => {
                const checkFullscreen = () => {
                    const fullscreen = viewport.isFullscreen() ?? true; // Default true for mobile
                    setIsFullscreen(fullscreen);
                };

                checkFullscreen();

                // Listen for fullscreen changes
                if (viewport.on) {
                    viewport.on('fullscreen_changed', checkFullscreen);
                }
            }, 100);
        } catch (err) {
            console.warn('Failed to setup fullscreen check:', err);
            // Assume fullscreen on error for mobile
            setIsFullscreen(true);
        }
    }, []);

    useEffect(() => {
        const fetchUptime = async () => {
            try {
                const data = await api.get('/api/stats/system');
                if (data && data.uptime) {
                    setUptime(data.uptime);
                } else {
                    console.warn('⚠️ No uptime in response:', data);
                }
            } catch (error) {
                console.error('❌ Failed to fetch uptime:', error);
            }
        };

        // Fetch initially
        fetchUptime();

        // Update every minute
        const interval = setInterval(fetchUptime, 60000);

        return () => clearInterval(interval);
    }, []);

    const days = Math.floor(uptime / 86400);
    const hours = Math.floor((uptime % 86400) / 3600);
    const minutes = Math.floor((uptime % 3600) / 60);

    // Don't render if no uptime data
    if (!uptime || uptime === 0) {
        return null;
    }

    // Only show on mobile and in fullscreen
    if (!isMobile) {
        return null;
    }

    if (!isFullscreen) {
        return null;
    }

    return (
        <div
            className="fixed top-[calc(var(--tg-content-safe-area-inset-top)+16px)] left-0 right-0 z-50 pointer-events-none">
            <div className="flex justify-center">
                <p
                    style={{color: themeParams.hintColor}}
                    className="text-xs font-bold bg-theme-section-separator-color/50 text-theme-section-separator-color px-3 pb-[7px] pt-2 rounded-full pointer-events-auto"
                >
                    {days}d {hours}h {minutes}m
                </p>
            </div>
        </div>
    );
}
